import BsFiltersContainer from './index.vue'
export default BsFiltersContainer